import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import ns from "@/lib/utils/NotificationService";
import {
    handleIndividualProfileCreate,
    handleIndividualProfileUpdate,
    handleIndividualProfileFetch,
    clearApiResponses,
    clearIndividualProfile,
} from "./store/IndividualProfile";
import { PrembidLocalStorage } from "@/lib/utils/PrembidLocalStorage";

import {
    Button,
    Card,
    List,
    ListItem,
    TextField,
    Grid,
    Container,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TableCell,
    TableContainer,
    CircularProgress,
    Switch,
    FormControlLabel,
    Alert
} from "@mui/material";
import { FaSave, FaTimes } from "react-icons/fa";
import {
    hideProgressSpinner,
    showProgressSpinner,
} from "@/lib/utils/ProgressSpinnerService";
import {
    handleDocumentDelete,
    retrieveProfileDocuments,
} from "@/pages/Documents/store/Documents";
import { isValidEmail, isValidPhoneNumber } from "../../lib/utils/General";
import SetObjectValue from "lodash/set";
import { forEach } from "lodash";
import { uploadRegistrationProcessDocuments } from "../../components/RegistrationProcess/store/RegistrationModal";
import { v4 as uuidv4 } from "uuid";
import { downloadFile } from "@/pages/Documents/store/Documents";
import useHistory from "../../lib/hooks/useHistory";
import { FileUploader } from "../../components/composite/FileUploader";

interface Props {
    handleIndividualProfileCreate_d: (formFields: any) => void;
    handleIndividualProfileUpdate_d: (formFields: any) => void;
    handleIndividualProfileFetch_d: (id: string) => void;
    handleDocumentDelete_d: (documentId: string) => void;
    retrieveProfileDocuments: (
        profileId: string,
        onCompletedCallback: (res: any) => void
    ) => void;
    uploadProfileDocuments: (
        data: any,
        onCompletedCallback: (res: any) => void
    ) => void;
    clearApiResponses_d: () => void;
    clearIndividualProfile_d: () => void;
    error: boolean;
    errorText: string;
    reload: boolean;
    success: boolean;
    profile: any;
    profileId: any;
    loading: boolean;
    documents: any;
    settings: any;
    renderSpaceAtTop?: boolean;
    overrideButtonSection?: (
        onClose?: () => void,
        onBack?: () => void,
        onSubmit?: () => void
    ) => JSX.Element;
    onCloseCallback?: () => void;
    onBackCallback?: () => void;
    onSubmitCallback?: (data?: any) => void;
    registrationProcess?: boolean;
    downloadFile_d: (url: string, onCompletedCallback?: (res: any) => void) => void,
}

const IndividualProfileAddEdit: React.FC<Props> = (props) => {
    const history = useHistory();

    const {
        handleIndividualProfileCreate_d,
        handleIndividualProfileUpdate_d,
        handleIndividualProfileFetch_d,
        uploadProfileDocuments,
        retrieveProfileDocuments,
        clearApiResponses_d,
        clearIndividualProfile_d,
        error,
        errorText,
        profile,
        profileId,
        success,
        loading,
        settings,
        renderSpaceAtTop = true,
        overrideButtonSection,
        onCloseCallback,
        onBackCallback,
        onSubmitCallback,
        registrationProcess = false,
        downloadFile_d
    } = props;

    const [formFields, setFormFields] = React.useState({
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        isDefaultProfile: null,
        address: {
            addressId: "",
            addressLine1: "",
            addressLine2: "",
            country: "",
            state: "",
            city: "",
            zip: "",
            longitude: 0,
            latitude: 0,
        },
    });

    const [formFieldsValidationShowErrors, setFormFieldsValidationShowErrors] =
        React.useState<any>({
            firstName: false,
            lastName: false,
            email: false,
            phoneNumber: false,
            address: {
                addressLine1: false,
                country: false,
                state: false,
                city: false,
                zip: false,
            },
        });

    const intialValuesErrors = {
        phoneNumber: "",
        email: "",
    };
    const [formErrors, setFormErrors] = React.useState(intialValuesErrors);
    const [individualProfileDocuments, setIndividualProfileDocuments] =
        React.useState<any>([] as any);
    const [tabErrorsShow, setTabErrorsShow] = React.useState<any>({
        individualInfo: false,
        addressInfo: false,
        documentInfo: false,
    });
    const [activeTab, setActiveTab] = React.useState("0");

    const [profileDocuments, setProfileDocuments] = useState<any[]>([]);
    const [loadingDocuments, setLoadingDocuments] = useState<boolean>(true);

    useEffect(() => {
        if (history.location) {
            const profileId = new URLSearchParams(history.location.search).get("profileId");
            if (profileId) {
                showProgressSpinner({
                    description: "Retrieving Individual Profile...",
                });
                handleIndividualProfileFetch_d(profileId);
                setLoadingDocuments(true);
                retrieveProfileDocuments(profileId, (res: any) => {
                    if (res.success) setIndividualProfileDocuments(res.response);
                    setLoadingDocuments(false);
                });
            } else {
                clearIndividualProfile_d();
                setLoadingDocuments(true);
                retrieveProfileDocuments(
                    "00000000-0000-0000-0000-000000000000",
                    (res: any) => {
                        if (res.success) setIndividualProfileDocuments(res.response);
                        setLoadingDocuments(false);
                    }
                );
            }
        }
        window.scroll({ top: 0, left: 0, behavior: "auto" });
    }, []);

    useEffect(() => {
        if (individualProfileDocuments) {
            let newDocList: any[] = [];
            forEach(individualProfileDocuments, (item: any) => {
                if (item.documentResult.documents?.length > 0)
                    forEach(item.documentResult.documents, (document) => {
                        newDocList.push({
                            id: document.id,
                            documentUrl: document.documentUrl,
                            documentTemplateId: item.documentResult.documentTemplate.id,
                            documentTemplateName: item.documentResult.documentTemplate.name,
                            isUploadMandatory:
                                item.documentResult.documentTemplate.dataCaptured
                                    .individualProfile.isUploadMandatory,
                            isAccessDriven:
                                item.documentResult.documentTemplate.dataCaptured
                                    .individualProfile.isAccessDriven,
                            documentBase64String: "",
                            replaceOnExist: true,
                        });
                    });
                else {
                    newDocList.push({
                        id: uuidv4(),
                        documentUrl: "",
                        documentTemplateId: item.documentResult.documentTemplate.id,
                        documentTemplateName: item.documentResult.documentTemplate.name,
                        isUploadMandatory:
                            item.documentResult.documentTemplate.dataCaptured
                                .individualProfile.isUploadMandatory,
                        isAccessDriven:
                            item.documentResult.documentTemplate.dataCaptured
                                .individualProfile.isAccessDriven,
                        documentBase64String: "",
                        replaceOnExist: true,
                    });
                }
            });
            const sortedList = newDocList.sort((a: any, b: any) =>
                b.isUploadMandatory
                    .toString()
                    .localeCompare(a.isUploadMandatory.toString())
            );
            setProfileDocuments(sortedList);
        }
    }, [individualProfileDocuments]);

    useEffect(() => {
        if (success) {
            ns.success("", "Individual profile successfully saved");
            clearApiResponses_d();

            let currentProfileId = profileId;
            if (!currentProfileId) {
                currentProfileId = new URLSearchParams(history.location.search).get(
                    "profileId"
                );
            }

            PrembidLocalStorage.upsertProfileToCurrentUser(
                currentProfileId,
                formFields.firstName + " " + formFields.lastName,
                formFields.email,
                formFields.phoneNumber,
                formFields.isDefaultProfile
            );

            const documentsPayload = {
                profileId: currentProfileId,
                profileDocuments:
                    profileDocuments.filter((x) => x.documentBase64String?.length > 0) ??
                    [],
            };

            if (documentsPayload.profileDocuments.length > 0) {
                showProgressSpinner({ description: "Uploading documents..." });
                uploadProfileDocuments(documentsPayload, (res) => {
                    hideProgressSpinner();
                    if (res.success) {
                        if (onSubmitCallback) onSubmitCallback({ id: currentProfileId });
                        else history.push("/biddingProfileList");
                    } else {
                        ns.error("", "Failed to upload a document.");
                    }
                });
            } else {
                hideProgressSpinner();
                if (onSubmitCallback) onSubmitCallback({ id: currentProfileId });
                else history.push("/biddingProfileList");
            }
        }
    }, [success]);

    React.useEffect(() => {
        if (profile) {
            hideProgressSpinner();

            const newProfile = {
                id: profile.id,
                firstName: profile.firstName,
                lastName: profile.lastName,
                email: profile.email,
                phoneNumber: profile.phoneNumber,
                isDefaultProfile:profile.isDefaultProfile,
                address: profile.address,
            };

            setFormFields(newProfile);
        } else {
            setFormFields({
                id: "",
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                isDefaultProfile:null,
                address: {
                    addressId: "",
                    addressLine1: "",
                    addressLine2: "",
                    country: "",
                    state: "",
                    city: "",
                    zip: "",
                    longitude: 0,
                    latitude: 0,
                },
            });
            hideProgressSpinner();
        }
    }, [profile]);

    React.useEffect(() => {
        if (error) {
            clearApiResponses_d();
            ns.error("", errorText);
            hideProgressSpinner();
        }
    }, [error]);

    const onKeyPress = (e) => {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    const onChange = (e: any) => {
        const props = e.target.id.split(".");

        if (props[0] === "address") {
            if (e.target.id.includes("zip")) {
                if (!/[0-9]/.test(e.target.value) && e.target.value.length > 0) {
                    e.preventDefault();
                } else {
                    setFormFields({
                        ...formFields,
                        address: { ...formFields.address, [props[1]]: e.target.value },
                    });
                }
            } else {
                setFormFields({
                    ...formFields,
                    address: { ...formFields.address, [props[1]]: e.target.value },
                });
            }

            return;
        }

        if (props[0] === "isDefaultProfile"){
            setFormFields({ ...formFields, [props[0]]: e.target.checked });

            return;
        }

        if (props[0] === "phoneNumber") {
            if (!/[0-9]/.test(e.target.value) && e.target.value.length > 0) {
                e.preventDefault();
            } else {
                setFormFields({ ...formFields, [props[0]]: e.target.value });
            }
        } else {
            setFormFields({ ...formFields, [props[0]]: e.target.value });
        }
    };

    const validateRegex = () => {
        let isValid = true;
        if (!isValidEmail(formFields.email.replace(" ", ""))) {
            isValid = false;
            formErrors.email = "Please enter a valid email address.";
            setTabErrorsShow({
                individualInfo: true,
                addressInfo: false,
                documentInfo: false,
            });
        }

        if (!isValidPhoneNumber(formFields.phoneNumber)) {
            isValid = false;
            formErrors.phoneNumber = "Please enter a valid phone number.";
            setTabErrorsShow({
                individualInfo: true,
                addressInfo: false,
                documentInfo: false,
            });
        }
        return isValid;
    };

    const validateAll = () => {
        let isAllValid = false;
        let isIndividualInfoValid = true;
        let isAddressValid = true;
        let isDocumentValid = true;

        let newState = {
            firstName: false,
            lastName: false,
            email: false,
            phoneNumber: false,
            address: {
                addressLine1: false,
                country: false,
                state: false,
                city: false,
                zip: false,
            },
        };

        setTabErrorsShow({
            individualInfo: false,
            addressInfo: false,
            documentInfo: false,
        });

        // Validate all properties not in address
        for (const [key, value] of Object.entries(formFieldsValidationShowErrors)) {
            const formFieldsValue = formFields[key]?.toString().trim() || ""; // Convert to string and trim
            if (formFieldsValue.length === 0) {
                isIndividualInfoValid = false;
                SetObjectValue(newState, key, true);
            } else {
                SetObjectValue(newState, key, false);
            }
        }

        // Validate address fields
        for (const [key, value] of Object.entries(formFieldsValidationShowErrors.address)) {
            const formFieldsValue = formFields.address[key]?.toString().trim() || ""; // Convert to string and trim
            if (formFieldsValue.length === 0) {
                isAddressValid = false;
                SetObjectValue(newState, `address.${key}`, true);
            } else {
                SetObjectValue(newState, `address.${key}`, false);
            }
        }

        if (isAddressValid && isIndividualInfoValid) {
            isAllValid = true;
        }

        setFormFieldsValidationShowErrors(newState);

        setTabErrorsShow({
            individualInfo: !isIndividualInfoValid,
            addressInfo: !isAddressValid,
            documentInfo: !isDocumentValid,
        });

        return isAllValid;
    };

    const validateField = (e: any) => {
        const trimmedValue = e.target.value?.toString().trim() || ""; // Ensure it's a string before trimming
        const props = e.target.id.split(".");
        let showError = trimmedValue.length === 0; // If no non-space characters, mark as invalid

        if (props[0] === "address") {
            setFormFieldsValidationShowErrors(prev => ({
                ...prev,
                address: { ...prev.address, [props[1]]: showError }
            }));
        } else {
            const fieldKey = e.target.id || e.target.name;
            setFormFieldsValidationShowErrors(prev => ({
                ...prev,
                [fieldKey]: showError
            }));
        }
    };

    const onCancel = () => {
        if (onCloseCallback) onCloseCallback();
        else history.push(`/biddingProfileList`);
    };

    const onSubmit = () => {
        const isValid = validateAll();

        if (isValid) {
            const isValidRegex = validateRegex();

            if (isValidRegex) {
                showProgressSpinner({ description: "Saving Individual Profile..." });
                if (profile) {
                    handleIndividualProfileUpdate_d(formFields);
                } else {
                    handleIndividualProfileCreate_d(formFields);
                }
            } else {
                hideProgressSpinner();
            }
        } else {
            hideProgressSpinner();
            ns.error("", "Please fill in all required fields");
        }
    };

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const handleFileUpload = (item, file) => {
        let existingDocIndex = profileDocuments.findIndex((x) => x.id === item.id);

        let tempDoc: any = {
            ...(existingDocIndex > -1 ? profileDocuments[existingDocIndex] : {}),
            documentBase64String: file ? file.base64 : "",
        };

        let tempList = [...profileDocuments];

        if (existingDocIndex > -1) {
            tempList.splice(existingDocIndex, 1, tempDoc);
        } else tempList.push(tempDoc);
        setProfileDocuments(tempList);
    };

    const handleViewDocument = (url: string) => {
        downloadFile_d(url, (response: any) => {
            if (response) {
                response.blob().then(blob => {
                    const fileURL = URL.createObjectURL(blob);
                    window.open(fileURL, '_blank', 'noreferrer');
                });
            }
        })
    }

    // Editing an existing profile (id passed in, or in the address) vs creating one: titles and button text follow, as on mobile.
    const isEditing = !!(profileId || new URLSearchParams(history.location.search).get("profileId"));

    return (
        <div
            style={{
                background: !registrationProcess && settings?.Styles?.OverridePageBackgroundColor || undefined,
            }}
        >
            <Container className={renderSpaceAtTop ? "pb-page" : "p-0"}>
                {renderSpaceAtTop && (
                    <div className="pb-page-head">
                        <div>
                            <h1>{isEditing ? "Edit individual profile" : "Add individual profile"}</h1>
                            <p>Keep this profile's details and documents up to date.</p>
                        </div>
                    </div>
                )}
                <div className={"pb-profile-form" + (renderSpaceAtTop ? " pb-profile-form--page" : "")}>
                    <List className="pb-tabs">
                        <ListItem
                            button
                            disableRipple
                            selected={activeTab === "0"}
                            onClick={() => {
                                toggle("0");
                            }}
                        >
                            Individual Information
                            {tabErrorsShow.individualInfo && (
                                <div className="badge badge-danger m-1 badge-circle">
                                    Danger
                                </div>
                            )}
                        </ListItem>
                        <ListItem
                            button
                            disableRipple
                            selected={activeTab === "1"}
                            onClick={() => {
                                toggle("1");
                            }}
                        >
                            Billing Address Information
                            {tabErrorsShow.addressInfo && (
                                <div className="badge badge-danger m-1 badge-circle">
                                    Danger
                                </div>
                            )}
                        </ListItem>
                        <ListItem
                            button
                            disableRipple
                            selected={activeTab === "2"}
                            onClick={() => {
                                toggle("2");
                            }}
                        >
                            Document Information
                        </ListItem>
                    </List>

                    <div className="p-3">
                        <div
                            className={
                                "tab-item-wrapper " + (activeTab === "0" ? "active" : "")
                            }
                            key={0}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                spacing={0}
                            >
                                <Grid item lg={12} className="pr-3">
                                    <TextField
                                        value={formFields.firstName}
                                        onChange={onChange}
                                        id="firstName"
                                        fullWidth
                                        variant="outlined"
                                        margin="dense"
                                        className='m-1 mt-2'
                                        label="First Name"
                                        required
                                        onBlur={validateField}
                                        error={formFieldsValidationShowErrors.firstName}
                                    />
                                    <TextField
                                        value={formFields.lastName}
                                        onChange={onChange}
                                        id="lastName"
                                        fullWidth
                                        variant="outlined"
                                        margin="dense"
                                        className='m-1 mt-2'
                                        label="Last Name"
                                        required
                                        onBlur={validateField}
                                        error={formFieldsValidationShowErrors.lastName}
                                    />
                                    <TextField
                                        value={formFields.email}
                                        onChange={onChange}
                                        id="email"
                                        fullWidth
                                        variant="outlined"
                                        margin="dense"
                                        className='m-1 mt-2'
                                        label="Email"
                                        required
                                        onBlur={validateField}
                                        error={formFieldsValidationShowErrors.email}
                                        onKeyDown={(e) => e.key === " " && e.preventDefault()}
                                    />
                                    {formErrors.email && (
                                        <Alert className="ml-2" severity="error">
                                            {formErrors.email}
                                        </Alert>
                                    )}

                                    <TextField
                                        value={formFields.phoneNumber}
                                        onChange={onChange}
                                        onKeyPress={onKeyPress}
                                        id="phoneNumber"
                                        fullWidth
                                        variant="outlined"
                                        label="Phone Number"
                                        margin="dense"
                                        className='m-1 mt-2'
                                        required
                                        onBlur={validateField}
                                        error={formFieldsValidationShowErrors.phoneNumber}
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                    />
                                    {
                                        formFields.isDefaultProfile!==null && (
                                            <FormControlLabel
                                                style={{marginLeft:2}}
                                                control={
                                                    <Switch
                                                        id='isDefaultProfile'
                                                        onChange={onChange}
                                                        className="m-2 p-2 switch-medium toggle-switch-success"
                                                        checked={formFields.isDefaultProfile ?? false}
                                                    />
                                                }
                                                label="Is Default Profile"
                                            />

                                        )
                                    }

                                    {formErrors.phoneNumber && (
                                        <Alert className="ml-2" severity="error">
                                            {formErrors.phoneNumber}
                                        </Alert>
                                    )}
                                </Grid>
                            </Grid>
                        </div>

                        <div
                            className={
                                "tab-item-wrapper " + (activeTab === "1" ? "active" : "")
                            }
                            key={1}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                                spacing={0}
                            >
                                <Grid item lg={12} className="pr-3">
                                    <TextField
                                        value={formFields.address.addressLine1}
                                        onChange={onChange}
                                        id="address.addressLine1"
                                        fullWidth
                                        variant="outlined"
                                        margin="dense"
                                        className='m-1 mt-2'
                                        label="Billing Address Line 1"
                                        required
                                        onBlur={validateField}
                                        error={formFieldsValidationShowErrors.address.addressLine1}
                                    />
                                    <TextField
                                        value={formFields.address.addressLine2}
                                        onChange={onChange}
                                        id="address.addressLine2"
                                        fullWidth
                                        variant="outlined"
                                        margin="dense"
                                        className='m-1 mt-2'
                                        label="Billing Address Line 2"
                                    />
                                </Grid>

                                <Grid item lg={6} className="pr-3">
                                    <TextField
                                        value={formFields.address.country}
                                        onChange={onChange}
                                        id="address.country"
                                        fullWidth
                                        variant="outlined"
                                        margin="dense"
                                        className='m-1 mt-2'
                                        label="Country"
                                        required
                                        onBlur={validateField}
                                        error={formFieldsValidationShowErrors.address.country}
                                    />
                                </Grid>
                                <Grid item lg={6} className="pr-3">
                                    <TextField
                                        value={formFields.address.state}
                                        onChange={onChange}
                                        id="address.state"
                                        fullWidth
                                        variant="outlined"
                                        margin="dense"
                                        className='m-1 mt-2'
                                        label="State / Province"
                                        required
                                        onBlur={validateField}
                                        error={formFieldsValidationShowErrors.address.state}
                                    />
                                </Grid>
                                <Grid item lg={6} className="pr-3">
                                    <TextField
                                        value={formFields.address.city}
                                        onChange={onChange}
                                        id="address.city"
                                        fullWidth
                                        variant="outlined"
                                        margin="dense"
                                        className='m-1 mt-2'
                                        label="City"
                                        required
                                        onBlur={validateField}
                                        error={formFieldsValidationShowErrors.address.city}
                                    />
                                </Grid>
                                <Grid item lg={6} className="pr-3">
                                    <TextField
                                        value={formFields.address.zip}
                                        onKeyPress={onKeyPress}
                                        onChange={onChange}
                                        id="address.zip"
                                        fullWidth
                                        variant="outlined"
                                        margin="dense"
                                        className='m-1 mt-2'
                                        label="Zip/Postal Code"
                                        required
                                        onBlur={validateField}
                                        error={formFieldsValidationShowErrors.address.zip}
                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                                    />
                                </Grid>
                            </Grid>
                        </div>

                        <div
                            className={
                                "tab-item-wrapper " + (activeTab === "2" ? "active" : "")
                            }
                            key={2}
                        >
                            <div className="table-responsive-md">
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableCell>Document Name</TableCell>
                                            <TableCell />
                                            <TableCell />
                                            <TableCell />
                                        </TableHead>
                                        <TableBody>
                                            {loadingDocuments && (
                                                <TableCell
                                                    scope="row"
                                                    colSpan={4}
                                                    style={{ textAlign: "center" }}
                                                >
                                                    <p>Loading profile documents...</p>
                                                    <div
                                                        className="d-flex flex-direction-column align-items-center justify-content-center"
                                                        style={{ paddingBottom: 20 }}
                                                    >
                                                        <CircularProgress
                                                            className="text-center"
                                                            style={{
                                                                margin: "auto",
                                                                color: settings?.Styles
                                                                    ?.OverrideLoadingSpinnerColor
                                                                    ? settings?.Styles
                                                                        ?.OverrideLoadingSpinnerColor
                                                                    : settings?.Styles?.Primary,
                                                            }}
                                                        />
                                                    </div>
                                                </TableCell>
                                            )}
                                            {!loadingDocuments &&
                                                profileDocuments.map((row, index) => (
                                                    <TableRow className='m-1 mt-2' key={index}>
                                                        <TableCell hidden component="th" scope="row">
                                                            {row.documentId}
                                                        </TableCell>
                                                        <TableCell hidden component="th" scope="row">
                                                            {row.documentTemplateId}
                                                        </TableCell>
                                                        <TableCell scope="row">
                                                            {row.documentTemplateName}
                                                        </TableCell>
                                                        <TableCell scope="row">
                                                            {row.documentUrl &&
                                                                row.documentUrl.length > 0 && (
                                                                    <a
                                                                        className="text-info"
                                                                        href={undefined}
                                                                        onClick={() => handleViewDocument(row.documentUrl)}
                                                                        style={{
                                                                            textDecoration: 'underline', cursor: 'pointer'
                                                                        }}
                                                                    >View</a>
                                                                )}
                                                        </TableCell>
                                                        <TableCell scope="row">
                                                            <FileUploader
                                                                uploadedFile={row.documentBase64String}
                                                                buttonFileUploadedText={"Attached"}
                                                                acceptedFileExtensions={".jpeg, .jpg, .png, .pdf"}
                                                                onFileUpload={(file) => handleFileUpload(row, file)}
                                                                maxImageSize={10240}
                                                                maxFileSize={10240}
                                                                buttonSize={120}
                                                                buttonText={"Upload"}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </div>
                </div>
                {overrideButtonSection ? (
                    <div style={{ marginTop: 10 }}>
                        {overrideButtonSection(onCancel, onBackCallback, onSubmit)}
                    </div>
                ) : (
                    <div className="pb-form-actions">
                        <Button
                            onClick={onCancel}
                            variant="contained"
                            className="btn-danger p-3 text-white m-1 text-capitalize"
                            size="large"
                        >
                            <span className="btn-wrapper--icon">
                                <FaTimes />
                            </span>
                            <span className="btn-wrapper--label">Cancel</span>
                        </Button>

                        <Button
                            onClick={onSubmit}
                            variant="contained"
                            className="btn-primary p-3 text-white m-1 text-capitalize"
                            size="large"
                        >
                            <span className="btn-wrapper--icon">
                                <FaSave />
                            </span>
                            <span className="btn-wrapper--label">{isEditing ? "Update Individual Profile" : "Add Individual Profile"}</span>
                        </Button>
                    </div>
                )}
                {error && <Alert severity="error">{errorText}</Alert>}
            </Container>
        </div>
    );
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleIndividualProfileCreate_d: (formFields: any) =>
            dispatch(handleIndividualProfileCreate(formFields)),
        handleIndividualProfileUpdate_d: (formFields: any) =>
            dispatch(handleIndividualProfileUpdate(formFields)),
        handleIndividualProfileFetch_d: (id: string) =>
            dispatch(handleIndividualProfileFetch(id)),
        handleDocumentDelete_d: (documentId: string) =>
            dispatch(handleDocumentDelete(documentId)),
        retrieveProfileDocuments: (
            profileId: string,
            onCompletedCallback: (res: any) => void
        ) =>
            dispatch(
                retrieveProfileDocuments(
                    profileId,
                    "individualProfile",
                    onCompletedCallback
                )
            ),
        uploadProfileDocuments: (
            data: any,
            onCompletedCallback: (res: any) => void
        ) =>
            dispatch(uploadRegistrationProcessDocuments(data, onCompletedCallback)),
        clearApiResponses_d: () => dispatch(clearApiResponses()),
        clearIndividualProfile_d: () => dispatch(clearIndividualProfile()),
        downloadFile_d: (url: any, onCompletedCallback?: (res: any) => void) => dispatch(downloadFile(url, onCompletedCallback)),
    };
};

const mapStateToProps = (state: any) => ({
    error: state.individualProfile.error,
    errorText: state.individualProfile.errorText,
    reload: state.individualProfile.reload,
    success: state.individualProfile.success,
    profile: state.individualProfile.profile,
    profileId: state.individualProfile.profileId,
    documents: state.documents.documents,
    loading: state.progressSpinner.loading,
    settings: state.settings.settings,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IndividualProfileAddEdit);
